import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NextActionsBox } from '../components/ControlPanelBoxes';

const NextActions = () => {
  const navigate = useNavigate();

  return (
    <main className="app-main">
      <div className="page-nav">
        <button className="back-btn" onClick={() => navigate('/control-panel')}>← Control Panel</button>
        <span className="page-nav__title">Blocked Order — Next Actions</span>
      </div>

      <NextActionsBox />
    </main>
  );
};

export default NextActions;
